import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarHeaderControlIconFn = /* @__PURE__ */ createRecipe('calendar-header-control-icon', {}, [])

const calendarHeaderControlIconVariantMap = {}

const calendarHeaderControlIconVariantKeys = Object.keys(calendarHeaderControlIconVariantMap)

export const calendarHeaderControlIcon = /* @__PURE__ */ Object.assign(memo(calendarHeaderControlIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarHeaderControlIcon',
  __getCompoundVariantCss__: calendarHeaderControlIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarHeaderControlIconVariantKeys,
  variantMap: calendarHeaderControlIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarHeaderControlIconVariantKeys)
  },
  getVariantProps: calendarHeaderControlIconFn.getVariantProps,
})